import { RootState } from '../store'

export const selectPrimaryAol = (state: RootState): number | string => {
  return state.user?.primaryAol
}
